module.exports = __webpack_public_path__ + "img/1.a90f186c.png";